import { FileText } from "lucide-react";
import { BiSolidFileTxt } from "react-icons/bi";
import { CiImageOn } from "react-icons/ci";
import { FaFilePdf } from "react-icons/fa";
import { SiAutocad, SiGoogledocs, SiGooglesheets } from "react-icons/si";

// A function to format dates in 'YYYY-MM-DD' format
export const formatDate = (date) => {
  const d = new Date(date);
  const month = "" + (d.getMonth() + 1);
  const day = "" + d.getDate();
  const year = d.getFullYear();

  return [year, month.padStart(2, "0"), day.padStart(2, "0")].join("-");
};

// export date in 28 Nov 2023 format
export const formatDateLong = (date) => {
  const d = new Date(date);
  const options = { year: "numeric", month: "short", day: "numeric" };
  return d.toLocaleDateString("en-IN", options);
};

// export date in 7:37 pm, 28 Nov 2023 format
export const formatDateTimeLong = (date) => {
  const d = new Date(date);
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };
  return d.toLocaleDateString("en-IN", options);
};

// export date in 7:37 pm if date < currentDate - 1min else show min ago
export const formatDateTimeShort = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const now = new Date();
  const diffInSeconds = Math.floor((now - d) / 1000);

  if (diffInSeconds > 60) {
    return d.toLocaleTimeString("en-IN", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  } else {
    return "Just now";
  }
};



export const formatCurrency = (amount) => {
  if (isNaN(amount)) return amount;

  const options = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  };

  return Number(amount).toLocaleString("en-IN", options);
}


export const fileTypeIcons = ({ fileType, className }) => {
  switch (fileType) {
    case "png":
      return <CiImageOn size={24} className={className} />;
    case "jpg":
      return <CiImageOn size={24} className={className} />;
    case "jpeg":
      return <CiImageOn size={24} className={className} />;
    case "pdf":
      return <FaFilePdf size={24} className={className} />;
    case "doc":
      return <SiGoogledocs size={24} className={className} />;
    case "docx":
      return <SiGoogledocs size={24} className={className} />;
    case "txt":
      return <BiSolidFileTxt size={24} className={className} />;
    case "xlsx":
      return <SiGooglesheets size={24} className={className} />
    case "dwg":
      return <SiAutocad size={24} className={className} />
    default:
      return <FileText size={24} className={className} />;
  }
}

export const roundOffNumber = (number) => {
  return Math.round(number);
}

export const roundOffToMaxDecimalPlaces = (number, maxDecimalPlaces) => {
  const factor = Math.pow(10, maxDecimalPlaces);
  return Math.round(number * factor) / factor;
}

export const padLeadingZeroes = (number, length) => {
  return number.toString().padStart(length, "0");
}